"use strict";

exports.__esModule = true;
var _DashboardScreen = require("./DashboardScreen");
Object.keys(_DashboardScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardScreen[key]) return;
  exports[key] = _DashboardScreen[key];
});